import { Navigate } from 'react-router-dom';
import { useSelector } from 'store';
import { ReactElement } from 'react';
import Loader from 'ui-component/Loader';
import { isAccountModuleEnabled, type AccountModuleId } from 'types/account/accountModules';
import { ACCOUNT_MODULE_UPGRADE_PATH } from 'utils/accountModuleMenuMap';

interface AccountModuleGuardProps {
  children: ReactElement | null;
  module: AccountModuleId;
}

/**
 * חוסם ראוט לפי מודול החשבון של החברה (CompanyAccount.modules_json, נערך ב-ops console).
 *
 * עד 5.11 מודול כבוי רק הוסיף תווית «לא כלול» לפריט בתפריט, והכתובת עצמה נשארה
 * פתוחה — מי שהקליד אותה ישירות נכנס. השומר הזה חוסם באמת.
 *
 * כל עוד המודולים לא נטענו מציגים Loader ולא חוסמים: חסימה על סמך מצב שטרם
 * נטען הייתה מעיפה משתמש מורשה באמצע רענון. כשל טעינה (hasError) נחשב «מותר»
 * מאותה סיבה — תקלת רשת לא אמורה לנעול פיצ'ר שהלקוח שילם עליו.
 */
export default function AccountModuleGuard({ children, module }: AccountModuleGuardProps) {
  const accountModules = useSelector((state) => state.accountModules);

  if (!accountModules.isLoaded && !accountModules.hasError) return <Loader />;
  if (accountModules.hasError || !accountModules.data) return children;
  if (!isAccountModuleEnabled(accountModules.data, module)) {
    return <Navigate to={ACCOUNT_MODULE_UPGRADE_PATH} replace />;
  }

  return children;
}
